import React from 'react';

/**
 * Catches render errors on hidden /admin/* routes only — no tokens or financial data in logs.
 */
export default class AdminRouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidUpdate(prevProps) {
    if (this.props.resetKey !== prevProps.resetKey && this.state.error) {
      this.setState({ error: null });
    }
  }

  componentDidCatch(error, info) {
    console.error('[admin] render_failed', error, info?.componentStack
      ? { componentStack: info.componentStack }
      : undefined);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen min-h-[100dvh] bg-[#0a0a0a] text-white flex items-center justify-center px-4">
          <div className="max-w-md w-full text-center space-y-4">
            <p className="text-sm text-gray-300 font-bold">
              Admin page failed to load. Refresh or contact support.
            </p>
            <button
              type="button"
              className="min-h-[44px] px-6 py-2 rounded-xl bg-violet-600 hover:bg-violet-500 text-white text-sm font-black"
              onClick={() => window.location.reload()}
            >
              Refresh
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
